const mParticle = require('./mparticle');

const servicesSupportingConsent = [mParticle];

/**
 * Delegate calling function with `functionName` on services
 *
 * @param {string} functionName Function to call in active services
 * @param {*} options values for tracking
 * @returns {Promise<Object>} result of track calls
 */
function delegate(functionName, options) {
  const validServices = servicesSupportingConsent.filter(
    s =>
      s.isActive() && s.consent && typeof s.consent[functionName] === 'function'
  );
  if (validServices.length === 0) {
    return Promise.resolve({ done: false });
  }

  const calls = validServices.map(service =>
    service.consent[functionName](options)
  );

  return Promise.all(calls).then(() => ({ done: true }));
}

/**
 * Update consent for the services that support it.
 *
 * @param {Object} options consent options
 * @returns {Promise<Object>} result of consent update
 */
function update(options) {
  return delegate('update', options);
}

module.exports = { update };
